<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="copyright text-center">
        2021 Lead distribution system
      </div>
    </div>
  </footer>
</template>
<script>
export default {}

</script>
<style>

</style>
